const sentEmailsFilterValue = [
  { name: 'subject', operator: 'contains', type: 'string', value: '' },
  { name: 'to', operator: 'contains', type: 'string', value: '' },
  { name: 'from', operator: 'contains', type: 'string', value: '' },
  { name: 'dateTime', operator: 'contains', type: 'string', value: '' },
  { name: 'attachments', operator: 'gte', type: 'number', value: '' },
  { name: 'emailType', operator: 'contains', type: 'string', value: '' },
];

export default sentEmailsFilterValue; 